export const catalogSortOptions = [
  { value: "price-asc", label: "Price: Low to high" },
  { value: "price-desc", label: "Price: High to low" },
  { value: "rating-asc", label: "Customer rating: Low to high" },
  { value: "rating-desc", label: "Customer rating: High to low" }
] as const;
export type CatalogSort = typeof catalogSortOptions[number]["value"];

export function sortCatalog<T extends { priceCents: number; rating: number; isBestSeller: boolean }>(items: T[], sort: CatalogSort): T[] {
  return [...items].sort((a, b) => {
    const pinned = Number(b.isBestSeller) - Number(a.isBestSeller);
    if (pinned) return pinned;
    const difference = sort.startsWith("rating") ? a.rating - b.rating : a.priceCents - b.priceCents;
    return sort.endsWith("desc") ? -difference : difference;
  });
}
